import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isNull',
    standalone: false
})
export class IsNullPipe implements PipeTransform {

  transform(value: any, type: string): string {
    if (value != null && value != undefined && value != '')
      return value;
    else if (type === 'string' || type === 'number')
      return '--';
    else if (type === 'date')
      return '--/--/----';
  }
}
